import React from 'react';
import { Registry } from '@/graphql/__generated__/onboarding-legal';
import TextSection from './TextSection';
interface LegalRepresentativeProps {
	registry: Registry;
}

export const LegalRepresentative: React.FC<LegalRepresentativeProps> = ({ registry }) => {
	return (
		<div className="space-y-3">
			<TextSection
				label="Names"
				value={registry.legalRepresentative?.names}
				field="Names"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="FirstLastName"
				value={registry.legalRepresentative?.firstLastName}
				field="FirstLastName"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="SecondLastName"
				value={registry.legalRepresentative?.secondLastName}
				field="SecondLastName"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="Email"
				value={registry.legalRepresentative?.email}
				field="Email"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="CURP"
				value={registry.legalRepresentative?.curp}
				field="Curp"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="Rfc"
				value={registry.legalRepresentative?.rfc}
				field="Rfc"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="DateOfBirth"
				value={registry.legalRepresentative?.dateOfBirth}
				field="DateOfBirth"
				sectionName="LegalRepresentative"
			/>
			<TextSection
				label="StateOfBirth"
				value={registry.legalRepresentative?.stateOfBirth}
				field="StateOfBirth"
				sectionName="LegalRepresentative"
			/>
		</div>
	);
};

export default LegalRepresentative;
